import React = require("react");
import ModuleData from "./ModuleData";
import { WebViewProps } from "../interfaces";

export interface HrWebViewProps extends WebViewProps<ModuleData>, React.Props<HrWebView> {
}

export default class HrWebView extends React.Component<HrWebViewProps, {}> {
    render() {
        return (
            <div style={{padding: `${this.props.payload.spacing}px 0px`}} >
                <div className="hr"></div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/hr/WebView.tsx
 **/